<template>
  <div>
    <a-form-model layout="inline" :model="searchForm">
      <a-form-model-item label="课程名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName" placeholder="请输入课程名称" />
      </a-form-model-item>
      <a-form-model-item label="课程类型">
        <a-select class="serach-item" allowClear v-model="searchForm.courseType" placeholder="请选择课程类型">
          <a-select-option value="1">测评</a-select-option>
          <a-select-option value="2">训练</a-select-option>
          <a-select-option value="3">活动</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="学段">
        <a-select allowClear v-model="searchForm.periodList" placeholder="请选择" mode="multiple" style="min-width: 180px">
          <a-select-option :value="item" :key="item" v-for="item in $data._period">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="search(1)" type="primary" html-type="button"> 查询 </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table
      style="min-width: 800px"
      :columns="columns"
      :scroll="{ y: 300 }"
      :rowKey="(text, index) => text.id + '_' + index"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <div slot="courseName" slot-scope="text">
        <span>{{ text.courseName }}{{ text.period ? ' - ' + text.period : '' }}</span>
      </div>
      <div slot="courseType" slot-scope="text">
        <span>{{ $data._courseType[text.courseType] }}</span>
      </div>
      <div slot="abilityTypeName" slot-scope="text">
        <div class="self_td" v-for="item in text.contentAbilitys" :key="item.id">
          <span v-if="text.contentType != 4">
            {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
            {{ item.secondAbilityName }}
          </span>
          <span v-else>{{ item.firstAbilityName }}</span>
        </div>
      </div>
      <div slot="contentDisplayOrder" slot-scope="text">
        <a-input-number disabled v-model="text.contentDisplayOrder" :min="0" :max="99999" class="table-input" />
      </div>
      <div slot="guideVideo" slot-scope="text">
        <a-switch disabled v-model="text.isLinkVedio" checked-children="启用" un-checked-children="禁用" />
      </div>
      <div slot="scoreSetting" slot-scope="text" class="table-ability">
        <div v-for="(item, index) in text.contentAbilitys" :key="index">
          <a-switch disabled v-model="item.isSetting" checked-children="启用" un-checked-children="禁用" />
        </div>
      </div>
      <div slot="fixedContent" slot-scope="text">
        <a-switch disabled v-model="text.isRegularContent" checked-children="启用" un-checked-children="禁用" />
      </div>
      <div slot="carryNumber" slot-scope="text">
        <!--<a-input-number :disabled="text.contentType !== 2" v-model="text.executionsNumber" :min="1" :max="99999" class="table-input" />-->
        <a-input-number disabled v-model="text.executionsNumber" :min="1" :max="99999" class="table-input" />
      </div>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '关联课程',
    scopedSlots: { customRender: 'courseName' },
  },
  {
    title: '学段',
    width: 100,
    dataIndex: 'period',
  },

  {
    title: '课程类型',
    scopedSlots: { customRender: 'courseType' },
  },
  {
    title: '内容排序',
    width: 100,
    scopedSlots: { customRender: 'contentDisplayOrder' },
  },
  {
    title: '内容名称',
    dataIndex: 'contentName',
  },
  {
    title: '版本名称',
    dataIndex: 'versionName',
  },
  {
    title: '内容类型',
    dataIndex: 'contentTypeName',
  },
  { title: '能力维度', class: 'testClass', key: 'abilityTypeName', width: 300, align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
  {
    title: '指导视频',
    width: 100,
    scopedSlots: { customRender: 'guideVideo' },
  },
  {
    title: '算分设置',
    width: 100,
    scopedSlots: { customRender: 'scoreSetting' },
  },
  {
    title: '固定内容',
    width: 100,
    scopedSlots: { customRender: 'fixedContent' },
  },
  {
    title: '执行次数',
    width: 100,
    scopedSlots: { customRender: 'carryNumber' },
  },
]
export default {
  name: 'fourthStep',
  props: {
    abilityList: {
      type: Array,
      value: [],
    },
    contentData: {
      type: Array,
      value: [],
    },
    type: String,
  },
  data() {
    return {
      searchForm: {
        courseName: undefined,
        childCourseDisplayOrder: undefined,
        contentDisplayOrder: undefined,
        childCourseName: undefined,
        childCourseType: undefined,
        periodList:[]
      },
      columns,
      tableRelevant: tableRelevant.call(this),
    }
  },
  mounted() {
    if (this.type === 'edit') {
      this.columns = [
        {
          title: '关联课程',
          scopedSlots: { customRender: 'courseName' },
        },
        {
          title: '学段',
          width: 100,
          dataIndex: 'period',
        },

        {
          title: '课程类型',
          scopedSlots: { customRender: 'courseType' },
        },
        {
          title: '内容排序',
          width: 100,
          scopedSlots: { customRender: 'contentDisplayOrder' },
        },
        { title: '能力维度', class: 'testClass', key: 'abilityTypeName', width: 300, align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
        {
          title: '指导视频',
          width: 100,
          scopedSlots: { customRender: 'guideVideo' },
        },
        {
          title: '算分设置',
          width: 100,
          scopedSlots: { customRender: 'scoreSetting' },
        },
        {
          title: '固定内容',
          width: 100,
          scopedSlots: { customRender: 'fixedContent' },
        },
        {
          title: '执行次数',
          width: 100,
          scopedSlots: { customRender: 'carryNumber' },
        },
      ]
    }
    this.tableRelevant.tableDataSource = JSON.parse(JSON.stringify(this.contentData))
  },
  methods: {
    search(pageIndex) {
      this.tableRelevant.tablePagination.current = 1
      this.tableRelevant.tableDataSource = this.contentData.filter((f) => {
        let bool = f.courseName.indexOf(this.searchForm.courseName || '') > -1
        if (this.searchForm.courseType) {
          bool = bool && this.searchForm.courseType == f.courseType
        }
        if (this.searchForm.periodList.length) {
          bool = bool && this.searchForm.periodList.includes(f.period)
        }
        return bool
      })
    },
  },
}
</script>

<style scoped lang="less">
.table-input /deep/ .ant-input-number-handler-wrap {
  display: none;
}

.table-input {
  width: 100%;
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
}

.table-input:focus {
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
}
.table-ability div:not(:last-child) {
  padding-bottom: 32px;
}
</style>
